import __vue_component__ from '../HseIcon/HseIcon.vue.js';
import { InteractionBubbles } from '@hse-design/core';
import __vue_component__$1 from '../HseSpinner/HseSpinner.vue.js';

//

var script = {
  name: 'HseButton',
  components: {
    HseIcon: __vue_component__,
    HseSpinner: __vue_component__$1
  },
  props: {
    /**
     * Произвольный цвет фона
     */
    color: {
      type: String,
      default: ''
    },
    /**
     * Размер кнопки
     * @values small, medium, large
     */
    size: {
      type: String,
      validator: (v) => ['small', 'medium', 'large'].includes(v),
      default: 'medium'
    },
    /**
     * Вариант отображения
     * @values primary, secondary, tertiary, tertiaryInvert
     */
    variant: {
      type: String,
      validator: (v) =>
        ['primary', 'secondary', 'tertiary', 'tertiaryInvert'].includes(v),
      default: 'primary'
    },
    /**
     * Неактивное состояние
     */
    inactive: {
      type: Boolean,
      default: false
    },
    /**
     * Заблокированное состояние
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Выбранное состояние
     */
    selected: {
      type: Boolean,
      default: false
    },
    /**
     * Компонент
     */
    component: {
      type: [String, Object],
      default: 'button'
    },
    /**
     * Спиннер
     * - при передаче `true` включается состояние `indeterminate`
     * - любое число – это процент заполнения (от 0 до 100)
     * - `done` – завершенное состояние
     */
    spinner: {
      type: [String, Number, Boolean],
      validator: (v) =>
        v ? ['boolean', 'number'].includes(typeof v) || v === 'done' : true,
      default: ''
    },
    /**
     * Положение спиннера
     * @values default, left, right
     */
    spinnerPosition: {
      type: String,
      validator: (v) => ['default', 'left', 'right'].includes(v),
      default: 'default'
    },
    /**
     * Иконка слева
     *
     */
    leftIcon: {
      type: [String, Object],
      default: ''
    },
    /**
     * Иконка справа
     */
    rightIcon: {
      type: [String, Object],
      default: ''
    },
    /**
     * Иконка слева
     * @deprecated используйте leftIcon
     */
    iconLeft: {
      type: [String, Object]
    },
    /**
     * Иконка справа
     * @deprecated используйте rightIcon
     */
    iconRight: {
      type: [String, Object]
    }
  },
  data() {
    return {
      interactionBubbles: InteractionBubbles.create(),
      focused: false
    };
  },
  computed: {
    leftIconComputed() {
      return this.leftIcon || this.iconLeft;
    },
    rightIconComputed() {
      return this.rightIcon || this.iconRight;
    },
    isSpinnerDefault() {
      const { spinner, spinnerPosition } = this;
      return spinner && spinner !== 'done' && spinnerPosition === 'default';
    },
    isSpinnerLeft() {
      const { spinner, spinnerPosition } = this;
      return spinner && spinnerPosition === 'left';
    },
    isSpinnerRight() {
      const { spinner, spinnerPosition } = this;
      return spinner && spinnerPosition === 'right';
    },
    hasLeft() {
      return (
        !this.isSpinnerDefault &&
        !!(this.isSpinnerLeft || this.$slots.left || this.leftIconComputed)
      );
    },
    hasRight() {
      return (
        !this.isSpinnerDefault &&
        !!(this.isSpinnerRight || this.$slots.right || this.rightIconComputed)
      );
    },
    enabled() {
      return !this.disabled && !this.inactive;
    },
    spinnerProps() {
      const { spinner } = this;

      const props = {
        class: 'hse-Button__spinner',
        size: this.size === 'small' ? 'small' : 'medium'
      };

      if (spinner === true) {
        props.loading = true;
      } else if (spinner === 'done') {
        props.done = true;
      } else if (typeof spinner === 'number') {
        props.value = spinner;
      }

      return props;
    },
    iconSize() {
      return this.size === 'small' ? 'small' : 'medium';
    },
    colorStyle() {
      const { color } = this;
      return color ? { color } : {};
    }
  },
  beforeDestroy() {
    this.interactionBubbles.onWillUnmount();
  },
  mounted() {
    this.warn();
    this.bubblesUpdate();
  },
  updated() {
    this.warn();
    this.bubblesUpdate();
  },
  methods: {
    onClick(e) {
      this.interactionBubbles.onClick();
      /**
       * Событие клика на кнопку
       * @type {MouseEvent}
       */
      this.$emit('click', e);
    },
    bubblesUpdate() {
      this.interactionBubbles.update({
        root: this.$refs.buttonBubble,
        enabled: this.enabled
      });
    },
    warn() {
      if (this.selected && this.variant !== 'tertiary') {
        console.warn(
          `'selected' state is only available with 'tertiary' variant.`
        );
      }
    },
    onFocus(e) {
      if (this.$el.classList.contains('focus-visible')) {
        this.focused = true;
      }
      /**
       * Событие фокуса
       * @type {FocusEvent}
       */
      this.$emit('focus', e);
    },
    onBlur(e) {
      this.focused = false;
      /**
       * Событие потери фокуса
       * @type {FocusEvent}
       */
      this.$emit('blur', e);
    }
  },
  watch: {
    iconLeft: {
      handler(v) {
        if (typeof v !== 'undefined')
          console.warn(
            `[${this.$options.name}]: Проп iconLeft помечен устаревшим и будет удален в следующем major релизе библиотеки. Используйте проп leftIcon.`
          );
      },
      immediate: true
    },
    iconRight: {
      handler(v) {
        if (typeof v !== 'undefined')
          console.warn(
            `[${this.$options.name}]: Проп iconRight помечен устаревшим и будет удален в следующем major релизе библиотеки. Используйте проп rightIcon.`
          );
      },
      immediate: true
    },
    is: {
      handler(v) {
        if (typeof v !== 'undefined')
          console.warn(
            `[${this.$options.name}]: Проп is помечен устаревшим и будет удален в следующем major релизе библиотеки. Используйте проп component.`
          );
      },
      immediate: true
    }
  }
};

export default script;
